"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HospitalSimple = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const HospitalSimple = _ref => {
  let {
    color = "currentColor",
    strokeWidth = 1.5,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M1.083 14.285h2.089m9.745 0H10.83m-7.658 0V3.182c0-.81.66-1.468 1.47-1.468h4.718c.81 0 1.47.659 1.47 1.468V14.285m-7.658 0H5.84m4.989 0H8.16m-2.32 0h2.32m-2.32 0v-3.411h2.32v3.411M7 7.5V6m0 0V4.5M7 6H5.5M7 6H8.5"
  }));
};
exports.HospitalSimple = HospitalSimple;
HospitalSimple.displayName = "HospitalSimple";